const REFERRAL_KEY = 'eleven_games_referral';

export function captureReferralFromUrl() {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  const ref = params.get('ref')?.trim().toUpperCase();
  if (ref) {
    localStorage.setItem(REFERRAL_KEY, ref);
    return ref;
  }
  return getStoredReferralCode();
}

export function getStoredReferralCode() {
  return localStorage.getItem(REFERRAL_KEY);
}

export function clearStoredReferralCode() {
  localStorage.removeItem(REFERRAL_KEY);
}
